var SENTRY_RELEASE;SENTRY_RELEASE={name: "frienzzi", version: "1.0.0"};